export default __webpack_public_path__ + "1fb8032bf938a3dcbed8c8661909d3ba.svg";